import {ChangeDetectorRef, Component, EventEmitter, Inject, NgZone, OnDestroy, OnInit} from '@angular/core';
import {MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef} from '@angular/material/bottom-sheet';
import {MatSliderModule} from "@angular/material/slider";
import {FormsModule} from "@angular/forms";
import {LayoutService} from "../../service/layout.service";
import {BackButtonService} from "../../service/back-button.service";
import {MatDialogClose} from "@angular/material/dialog";
import {MatIcon} from "@angular/material/icon";
import {MatIconButton} from "@angular/material/button";
import {translation} from "../../translation";
import {MatSelectModule} from "@angular/material/select";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import {MatButtonToggleModule} from "@angular/material/button-toggle";
import {MatOptionModule} from "@angular/material/core";
import {NgForOf} from "@angular/common";

@Component({
  selector: 'app-font-size',
  standalone: true,
  imports: [MatSliderModule, FormsModule, MatIcon, MatIconButton, MatSelectModule, MatOptionModule, MatFormFieldModule, MatSlideToggleModule, MatButtonToggleModule, NgForOf],
  templateUrl: './font-size.component.html',
  styleUrl: './font-size.component.scss'
})
export class FontSizeComponent implements OnInit, OnDestroy{

  labelLinesPerVerse = translation.label_lines_per_verse;
  labelFontSize = translation.label_font_size;
  labelFontWeight = translation.label_font_weight;
  labelAlignment = translation.label_alignment;
  labelTextOutline = translation.label_text_outline;
  constructor(@Inject(MAT_BOTTOM_SHEET_DATA) public data: {
                labelLinesPerVerse: string,
                labelFontSize: string,
                labelFontWeight: string,
                labelAlignment: string,
                labelTextOutline: string,

                min?: number,
                max?: number,
                currentFontSize?: number,
                fontSizeChange?: EventEmitter<number>,
                // New: dedicated visibility flags
                fontSizeEnabled?: boolean,
                linesPerVerseEnabled?: boolean,
                // New: font size slider params
                fontSizeMin?: number,
                fontSizeMax?: number,
                // New: lines per verse slider params
                linesPerVerseMin?: number,
                linesPerVerseMax?: number,
                currentLinesPerVerse?: number,
                linesPerVerseChange?: EventEmitter<number>,
                // font family
                fonts?: string[],
                currentFontFamily?: string | undefined,
                fontFamilyChange?: EventEmitter<string | undefined>,
                // font weight
                fontWeightEnabled?: boolean,
                currentFontWeight?: number | undefined,
                fontWeightChange?: EventEmitter<number | undefined>,
                // text outline
                textOutlineToggleEnabled?: boolean,
                textOutlineEnabled?: boolean,
                textOutlineChange?: EventEmitter<boolean>,
                // text alignment
                textAlignmentEnabled?: boolean,
                currentTextAlignment?: string,
                textAlignmentChange?: EventEmitter<string>
              },
              private ref: ChangeDetectorRef,
              private zone: NgZone,
              protected bottomSheetRef: MatBottomSheetRef<FontSizeComponent>,
              private layoutService: LayoutService,
              private backButtonService: BackButtonService) {
    this.backButtonService.registerBackButtonAction(() => {
      this.zone.run(() => {
        this.bottomSheetRef.dismiss();
      });
    });
  }

  // Back-compat handler for legacy single-slider usage (Font Size)
  onSliderChange() {
    if (this.data.fontSizeChange && typeof this.data.currentFontSize === 'number') {
      this.data.fontSizeChange.emit(this.data.currentFontSize);
    }
  }

  // New handlers
  onFontSizeSliderChange() {
    if (this.data.fontSizeChange && typeof this.data.currentFontSize === 'number') {
      this.data.fontSizeChange.emit(this.data.currentFontSize);
    }
  }

  onLinesPerVerseSliderChange() {
    if (this.data.linesPerVerseChange && typeof this.data.currentLinesPerVerse === 'number') {
      this.data.linesPerVerseChange.emit(this.data.currentLinesPerVerse);
    }
  }

  onFontChange(newFont: string | undefined) {
    if (this.data.fontFamilyChange) {
      this.data.fontFamilyChange.emit(newFont);
    }
  }

  onFontWeightChange() {
    if (this.data.fontWeightChange) {
      this.data.fontWeightChange.emit(this.data.currentFontWeight);
    }
  }

  onTextOutlineToggle(enabled: boolean) {
    if (this.data.textOutlineChange) {
      this.data.textOutlineChange.emit(enabled);
    }
  }

  onTextAlignmentChange(alignment: string) {
    if (this.data.textAlignmentChange) {
      this.data.textAlignmentChange.emit(alignment);
    }
  }

  ngOnInit(): void {
    this.layoutService.fontSizeSheetActive = true;
  }

  ngOnDestroy(): void {
    this.layoutService.fontSizeSheetActive = false;
  }
}
